module.exports = __webpack_public_path__ + "img/TZS09689.e37d91b2.jpeg";